import styled, { css } from "styled-components/macro";
import { Wrapper as StWrapper } from "components/Wrapper";
import rank1 from "assets/rank1.png";
import rank2 from "assets/rank2.png";
import rank3 from "assets/rank3.png";
import ring1 from "assets/ring1.svg";
import ring2 from "assets/ring2.svg";
import ring3 from "assets/ring3.png";
import topThreeStatBg from "assets/topThreeStatBg.png";

export const Wrapper = styled(StWrapper)`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  row-gap: 30px;

  @media (min-width: 1280px) {
    flex-wrap: nowrap;
    flex-direction: row;
    gap: 30px;
  }
`;

export const Card = styled.div<{ rank: number }>`
  position: relative;
  flex-basis: 100%;
  //min-height: 285px;
  width: 100%;
  background-position: center center;
  background-repeat: no-repeat;
  border-top: 1px solid;
  border-color: ${({ rank }) =>
    rank === 1 ? `#F2D18C` : rank === 2 ? `#E0E7ED` : `#E2B194`};
  background-image: url(data:image/png;base64,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);

  @media (min-width: 768px) {
    min-height: 195px;
    background-image: url(data:image/png;base64,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);
  }

  @media (min-width: 1280px) {
    flex-basis: 33%;

    min-height: 285px;
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAXIAAAEdCAYAAAARhuyGAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAeSSURBVHgB7d0rdBRnGMfhdwHX9Y1vPOsTX3wwVWBQrUdVUYOqqatJPPigYsAHv/jEL77zJjN0civ0nKbwh+c5Z2ZnhlsI5/z249u5LKrqqACIdacAiCbkAOGEHCCckAOEE3KAcEIOEE7IAcIJOUA4IQcIJ+QA4YQcIJyQA4QTcoBwQg4QTsgBwgk5QDghBwgn5ADhhBwgnJADhBNygHBCDhBOyAHCCTlAOCEHCCfkAOGEHCCckAOEE3KAcEIOEE7IAcIJOUA4IQcIJ+QA4YQcIJyQA4QTcoBwQg4QTsgBwgk5QDghBwgn5ADhhBwgnJADhBNygHBCDhBOyAHCCTlAOCEHCCfkAOGEHCCckAOEE3KAcEIOEE7IAcIJOUA4IQcIJ+QA4YQcIJyQA4QTcoBwQg4QTsgBwgk5QDghBwgn5ADhhBwgnJADhBNygHBCDhBOyAHCCTlAOCEHCCfkAOGEHCCckAOEE3KAcB3ykwIglhE5QDgjcoBwQg4QrkO+KQBimSMHCNch3y4AYnXIVwVALB92AoSb5sjFHCBUh3w5LMcFQKQp5EbkAKGmqZXdAiCS88gBwnXIe37c1ApAqLt1PkfeiwuDAAL1iPxtud8KQKwO+bqEHCCWC4IAwk0hNyIHCDWF/LQAiGREDpDnwnS4kAPkWc935iEXc4AMF252OL9EX8gBMvQDgV5OO0IOkOn7YTnsjXnInUsOkKPvWnvQG0bkAJl6eqW7vW9EDpBrZ1heGpED5DoblQs5QK6zp7uZWgHI1eeTr+Yhf18ApLlvagUg22px6cBRARDlzqV9o3KAMB3y1WxfyAHCdMifDcvWuO/MFYAwHfI+feXZ+CrkAGGmOfLtYXlUAMS5N9t+WEbkAHEun7WyVQBEuVMARBNygHBCDhBOyAFy9QOY1/cKgER9Jf4fw7JlRA6Q6+xCTiEHyNQR74s5zZEDBDvulZADhBNygHBCDhBOyAFy9QeeQg4Q7GmvhBwg17pXQg6Qy9QKQLgH5RJ9gGg9It8RcoBs74QcINeLYTkWcoBcb3ol5AC5HvVKyAFyuY0tQLg+a2VvMayOCoBYRuQA4YQcIJyQA4QTcoBwQg4QTsgBwgk5QK6TXgk5QK7jXgk5QC43zQIItinP7ASI9rrGux/eKwAS9Q2zdnvDiBwg02raEHKATMtpQ8gBwnXINwVArA75kxqvDgIgT4e8I35cAESa5si3C4BIHfL+5FPIAUJ1yH8oAGJ1yI3GAYJ1yFcFQCwjcoBwHfKtAiCWS/QBwgk5QDghBwgn5ADhhBwgnJADhBNygHBCDhBOyAHCCTlAOCEHCCfkAOGEHCCckAOEE3KAHJvrDgo5QI4Xw7K+fFDIAXL0ozmfDMvh/KCQA+ToR3Muh+X5sBxMB4UcIEdHfGfc3q8x5neH5XEBkKJj/mrcPh6WUyNygCw9T76c7R8KOUCeH+c7Qg6QZ3e+I+QAeXp6ZWvaEXKATE+nDSEHyNSj8rO5ciEHyPXLsCyFHCBXn4b4aDGsjgqAWEbkAOGEHCBch3xTAMQScoBwQg4QTsgBwnXITwqAWM5aAQhnRA4Qzhw5QDghBwgn5ADhhBwgXIf8tACI5fRDgHBOPwQIN43IzZMDhBJygHBCDhBuCrl5coBQRuQA4YQcIJyQA4QzRw4QzpWdAOGMyAHCTSF/XwBE8mEnQDghBwgn5ADh5met+MATIJDTDwGybYzIAbKt5yE3Tw6QZyPkANmMyAHCvRNygGwnPuwEyHbi9EOAXD2T4vRDgGDrXs1DfloAJDkbgJtaAch1ZURuagUgy9lMihE5QK5rp1aMygFyXJlaaS4KAsjwoddCDpDpwwyKqRWATDeOyAHIYEQOEO7GkJsjB8hwIeSr2Q8IOUCGD7dV6ZA/HZbluC/kAGE65Ft1HvMm5AAZ1tPGNEe+Oyx75Q6IAHHmH3Y+rvPROQBfvp1pYx7ynid/WgAkeDBtXD790IgcIMN2jSequLITIFNH/Oz0cSEHyHU2Ty7kALn6jEMhBwj2uldCDpDroFdCDpDpuG54ZicAGV5OG0IOkKdH4q+nHSEHyHMw3xFygCwXRuNNyAGy9IecF245LuQAWQ4uHxBygByHNXtW50TIAXK8uu6gkAPkWF53UMgBcvTDf648N0LIAXJc+yQ3IQfI0g+T+Hl+QMgB8jys8elATcgBMvUUi2d2AgTrDz2f9YaQA+Tq6ZW9xbA6KgBSbYzIr7ncFSDIskP+LYas/85945mfCiDcYnx9MCyP6porhr4ifdvHvuHMmzq/DWTrDwp269u2GZev+d8evmqLS/s3BX2K4Ntxv3/8u2HZrvPTX7bqyw5BP9tuvy7ew7f/no/r9vSN3/v78yV+X6Z/z35d1ex8VCDP4objHfS9Op+C6Age16eZwt6v92fby/o8+ut/Xle//p1h+a1u3/74NfT385++D+s6/59Cvzk+HI9Nt6t8X39Ht8bf52T8vX6vT3+jmP+PpH/93uzPAoIt6v8xj3u/rur2494j4o745tLxDt+/CeBt6q/t17r4RrM9vq4/8mv75/35kZ8zPRLqzfj79RtFv6l0wD/XmyvwH/sLTRzhl7p9G1UAAAAASUVORK5CYII=);
  }
  background-size: 100% 100%;
`;

export const CardHeader = styled.div`
  width: 95.5224%;
  margin: 5px auto 0;
  padding-top: 13px;
  padding-bottom: 13px;
  background: url(data:image/png;base64,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)
    no-repeat;
  color: #ffffff;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  text-transform: capitalize;
  opacity: 0.9;
  padding-left: 50px;
  box-sizing: border-box;
  cursor: pointer;

  @media (min-width: 768px) {
    width: 98.1944%;
  }
  @media (min-width: 1280px) {
    width: 95.4054%;
    margin: 5px 0 0 7px;
  }
`;

interface ICardHeaderRank {
  rank: number;
}
export const CardHeaderRank = styled.div<ICardHeaderRank>`
  width: 50px;
  height: 50px;
  background-image: url(${(props) =>
    props.rank === 1 ? rank1 : props.rank === 2 ? rank2 : rank3});
  background-position: 0 0;
  position: absolute;
  top: 0;
  left: 0;
`;

export const RankText = styled.span`
  color: rgb(0, 0, 0);
  font-weight: 700;
  font-size: 20px;
  line-height: 24px;
  margin-top: 4px;
  margin-left: 8px;
`;

export const CardContent = styled.div`
  box-sizing: border-box;
  display: flex;
  width: 100%;
  flex-flow: column wrap;
  margin-top: 0;

  @media (min-width: 768px) {
    flex-flow: row nowrap;
    margin-top: 30px;
    justify-content: space-between;
  }
  @media (min-width: 1280px) {
    flex-flow: column wrap;
    margin-top: 16px;
  }
`;

export const ScoreAndIcon = styled.div`
  box-sizing: border-box;
  flex-direction: row;
  height: 80px;
  margin-top: 16px;

  @media (min-width: 768px) {
    height: 100%;
    margin-top: 0;
    margin-left: 17px;
  }
`;

export const ScoreAndIconInner = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-flow: row wrap;
  width: 100%;
  padding-left: 3.58209%;

  @media (min-width: 768px) {
    padding-left: 0;
  }
`;

type IIconRing = {
  rank: number;
};

export const IconRing = styled.div<IIconRing>`
  box-sizing: border-box;
  margin: 0;
  flex-direction: row;
  width: 80px;
  height: 80px;

  background-image: url(${(props) =>
    props.rank === 1 ? ring1 : props.rank === 2 ? ring2 : ring3});
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-position: center center;
  padding: 12px;
`;

type IIcon = {
  icon: string;
  name: string;
  rank: number;
};
export const Icon = styled.img.attrs<IIcon>((props) => ({
  src: props.icon,
  alt: props.name,
}))<IIcon>`
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background-color: ${({ rank }) =>
    rank === 1 ? "#FECD02" : rank === 2 ? "#C6D3DE" : "#A89E86"};
`;

type IClanIcon = {
  name: string;
  rank: number;
};
export const ClanIcon = styled.div<IClanIcon>`
  display: flex;
  align-items: center;
  justify-content: center;

  &::before {
    font-weight: 600;
    content: "${({ name }) => name}";
    text-transform: uppercase;
  }

  box-sizing: border-box;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background-color: ${({ rank }) =>
    rank === 1 ? "#FECD02" : rank === 2 ? "#C6D3DE" : "#A89E86"};
  border: 1px solid;
  border-image-source: linear-gradient(
    88.27deg,
    rgba(255, 255, 255, 0.12) 4.49%,
    rgba(255, 255, 255, 0.32) 62.01%
  );
`;

export const ScoreWrapper = styled.div`
  margin-left: 12px;
`;

export const Score = styled.div`
  box-sizing: border-box;
  margin-top: 11px;
  flex-direction: row;
  color: rgba(255, 255, 255, 0.9);
  font-weight: 700;
  font-size: 28px;
  line-height: 34px;
  text-transform: uppercase;
`;
export const ScoreText = styled.div`
  color: rgb(255, 255, 255);
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  text-transform: uppercase;
  opacity: 0.6;
  margin: 4px 0 0;
`;
export const Separator = styled.div`
  box-sizing: border-box;
  flex-direction: row;
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0.06) 0%,
    rgba(255, 255, 255, 0.15) 49.83%,
    rgba(255, 255, 255, 0.06) 100%
  );
  width: 88.0597%;
  height: 1px;
  margin-top: 15px;

  @media (min-width: 768px) {
    width: 1px;
    height: 80px;
    margin-top: 0;
  }
  @media (min-width: 1280px) {
    width: 86.4865%;
    height: 1px;
    margin-top: 13px;
  }
`;

export const Stats = styled.div`
  box-sizing: border-box;
  flex-direction: row;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-auto-rows: 36px;
  row-gap: 8px;
  width: 88.0597%;
  margin: 20px auto;
  column-gap: 7px;
  @media (min-width: 768px) {
    width: 322px;
    margin: 0 23px 20px 0;
    column-gap: 6px;
  }
  @media (min-width: 1280px) {
    width: 86.4865%;
    margin: 20px auto;
  }
`;
export const StatsItem = styled.div<{ fullWidth?: boolean }>`
  display: flex;
  align-items: center;
  background-image: ${({ fullWidth }) =>
    fullWidth
      ? `url(${topThreeStatBg})`
      : `url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJwAAAAkCAYAAAB8IVNVAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAIxSURBVHgB7ZzZSsUwEIb/uoCIKy546Yv4/m8hqDdeuOGKuMSMPeXUkLZJGu++D4bSNk1KmDNJ/uZM45w70xLnrekdvxfH7p6CsuH17lnXOw/LuKAtjZQZqj+8PvYezUTZ2HnsPde97Xq7VNsvsWcUtBura6idsftN4rM5fdoM1OUS2i4+X1sczwUpfKp1tltBCc2KIId7b3ve6LdC6Lg8vry9ejsWlOBwuHxevO142xRkg8PlY3O4B28HglyYwxViw+qq2kgHGeBw5Tx5OxR9mAWdVc67tw9v+4JkcLh5PKqVSdYFSeBw80AmyQSHm4/JJBtCJkkCh5uPySQ2tCKTTIPwW4k3tTIJC4gJcLh6IJNM8yv8OkENTCaxSEeUG+Z3SG0EtejmcsgkcYhwlbEFhA2tJ4IYRLh/wH7AH4IoRLi62Ep1S+wIHoQVVV1s94jN44hwAzCk1sOimy0W7gVDsB+uIiaH3IjoNoZjDlcH+45qffkoGIUIVwebu10LpmiYw81n29uz2m1KMA5D6kxsoWAOhwySCEPqPGwovRMLhWRwuHI6GeROkAwOV86RWhnkW5AMDleGySDdTl/IAIfLx1b1Nne7EmSDw+VjH+dNBmGhUACySB7sBpkJwm8eNpTax3miWyFdBszT3rUw7epYutDU6y6h/rBsrP3+eezdxtKzTqVrnUprav89teh2oeX/FvqpS1NSp6bej71TSlrY2HUltBV7JuyPqbSqGij/p54frf+lIW172eUAAAAASUVORK5CYII=)`};
  background-position: center center;
  background-repeat: no-repeat;
  background-size: 100% 100%;

  ${({ fullWidth }) =>
    fullWidth &&
    css`
      grid-column: 1 / span 2;
    `}
`;
export const StatsItemImg = styled.img`
  margin-left: 10px;
  width: 18px;
  height: 18px;
`;

export const StatsItemText = styled.span`
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  color: rgb(255, 255, 255);
  text-transform: capitalize;
  margin-left: 8px;
`;
export const StatsItemCount = styled.span`
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  color: rgb(255, 255, 255);
  text-transform: capitalize;
  margin-left: auto;
  margin-right: 12px;
`;
